var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.loading } }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 mb-5" },
        [
          _c("dashboard-filters", {
            attrs: {
              value: _vm.filters,
              onChange: _vm.onChangeFilters,
              clear: _vm.clearFilters
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-7" },
        [
          _c("BarByState", {
            ref: "by-state",
            attrs: { data: _vm.batchIndicators, title: "Estados de lotes" }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-5" },
        [
          _c("BarByState", {
            ref: "by-state",
            attrs: { data: _vm.auctionIndicators, title: "Estados de subastas" }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c("Indicator", {
            attrs: {
              title: "Total Lotes",
              quantity: _vm.indicators.totalBatches,
              color: "primary",
              icon: "FileTextIcon"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c("Indicator", {
            attrs: {
              title: "Total Subastas",
              quantity: _vm.indicators.totalAuctions,
              color: "primary",
              icon: "FileTextIcon"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c("Indicator", {
            attrs: {
              title: "Total Comprobantes Emitidos",
              quantity: _vm.indicators.totalReceipts,
              color: "primary",
              icon: "FileTextIcon"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c("Indicator", {
            attrs: {
              title: "Total Comprobantes Facturados",
              quantity: _vm.indicators.totalInvoiceReceipts,
              color: "primary",
              icon: "FileTextIcon"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }